<template>
	<el-table v-loading="loading" :data="gridData">
		<el-table-column width="50" type="index" label="序号"></el-table-column>
		<el-table-column property="name" label="工序名称"></el-table-column>
		<el-table-column width="100" property="direction" label="进料方向"></el-table-column>
		<el-table-column width="120" label="选择工序" v-if="showSelect">
			<template slot-scope="scope">
				<el-button type="text" size="mini" @click="select(scope.$index, scope.row)">选择</el-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
	import { processGroupDetailRequest } from '@/network/requests/processGroupDetail'
	import { processInfoRequest, getDirectionName } from '@/network/requests/processInfo'
	export default {
		props: {
			groupId: {
				type: String,
				required: true,
			},
			showSelect: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				loading: false,
				gridData: [],
			}
		},
		watch: {
			groupId(val) {
				if (val) {
					this.loadData(val)
				} else {
					this.gridData = []
				}
			},
		},
		methods: {
			select(index, row) {
				this.$emit('select', { index, row })
			},
			loadData(groupId) {
				this.loading = true

				var p1 = processInfoRequest.queryAll()
				var p2 = processGroupDetailRequest.queryAll({ process_group_id: this.groupId }, undefined, { sequence: 1 })

				Promise.all([p1, p2])
					.then(result => {
						var process = result[0]
						var processDetails = result[1]

						var array = []
						processDetails.forEach(element => {
							var p = process.find(t => t._id.$oid == element.process_id)

							array.push({
								name: p?.name,
								direction: getDirectionName(p.is_end_in),
							})
						})

						this.gridData = array
					})
					.finally(() => {
						this.loading = false
					})
			},
		},
		created() {
			if (this.groupId) {
				this.loadData(this.groupId)
				return
			} else {
				this.gridData = []
			}
		},
	}
</script>

<style lang="less" scoped></style>
